export default {
    "Van Cranenbroek": "Van Cranenbroek",
    "Menu": "Menu",
    "What are you looking for?": "Was suchst du?",
    "back": "zur\u00fcck",
    "Filtering": "Filtern",
    "Clear all": "Alles l\u00f6schen",
    "Show more": "Mehr anzeigen",
    "Show less": "Weniger anzeigen",
    "Price": "Preis",
    "to": "bis",
    "Enter a correct value": "Geben Sie einen korrekten Wert ein",
    "Popularity": "Beliebtheit",
    "Newest": "Neueste",
    "Name (A-Z)": "Name (A-Z)",
    "Name (Z-A)": "Name (Z-A)",
    "Price (Ascending)": "Preis (Aufsteigend)",
    "Price (Descending)": "Preis (Absteigend)",
    "Categories": "Kategorien",
    "Apply": "Anwenden",
    "No products were found in this category.": "Es wurden keine Produkte in dieser Kategorie gefunden.",
    "More info": "Mehr Info",
    "Subscribe to our newsletter": "Abonniere unseren Newsletter",
    "Yes i subscribe!": "Ja, ich abonniere!",
    "Follow us": "Folge uns",
    "Show store": "Filiale anzeigen",
    "Quick access to": "Schnellzugriff auf",
    "In stock in {count} store(s)": "Auf Lager in {count} Filiale(n)",
    "Out of stock": "Nicht auf Lager",
    "In stock": "Auf Lager"
}